export default "__VITE_ASSET__Borb$jsb__"